module.exports = __webpack_public_path__ + "data/customer.json";


//////////////////
// WEBPACK FOOTER
// ./app/services/api/customers/customer.json
// module id = 4lQk
// module chunks = 1